export default "__VITE_ASSET__DDdlOnTK__"